import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "fixedGridIsOpen", true);
        Vue.set(state, "alaCarteGridIsOpen", false);
    },
    setAlaCarteGridOpen(state) {
        state.alaCarteGridIsOpen = true;
        state.fixedGridIsOpen = false;
    },
    setAlaCarteGridClose(state) {
        state.alaCarteGridIsOpen = false;
        state.fixedGridIsOpen = true;
    }
}
